import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

const pcIndex = () => import('@/views/pc/index/index')
const pcOrder = () => import('@/views/pc/order/order')
const pcDetail = () => import('@/views/pc/detail/detail')
const pcLogin = () => import('@/views/pc/login/login')
const pcOrderDetail = () => import('@/views/pc/orderDetail/orderDetail')


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/pc/index'
    },
    {
      path: '/pc/index',
      name: 'pcIndex',
      component: pcIndex,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/pc/order',
      name: 'order',
      component: pcOrder
    },
    {
      path: '/pc/detail',
      name: 'detail',
      component: pcDetail
    },
    {
      path: '/pc/login',
      name: 'pcLogin',
      component: pcLogin
    },
    {
      path: '/pc/orderDetail',
      name: 'pcOrderDetail',
      component: pcOrderDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js